import React from 'react';

const InfoSections = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-xl font-semibold">
            Important Information
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Trademark Essentials You Need to Know
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Before filing your trademark application, it's crucial to understand the common pitfalls that can lead to rejection and get a clear picture of the investment required. Knowledge of these key factors will help you navigate the trademark process successfully and budget appropriately for protecting your brand.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-16 max-w-7xl mx-auto">
          <div className="flex flex-col justify-center">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Common Reasons for Trademark Rejection</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Trademark applications can be rejected for several reasons, most commonly due to similarity with an existing trademark. If your mark is too similar to one already registered, it could cause confusion among consumers, leading to a refusal.
              </p>
              <p>
                Another common reason for rejection is failure to meet distinctiveness requirements—your mark must be unique and not merely descriptive of the product or service it represents. Incomplete or incorrect information in your application, such as improper classification of goods or services, can also lead to rejection.
              </p>
              <p>
                Additionally, trademarks containing offensive or prohibited content, such as those deemed scandalous or deceptive, will be denied. It's essential to thoroughly review your trademark and ensure it complies with all legal standards before submitting your application to avoid unnecessary rejections.
              </p>
            </div>
          </div>
          <div>
            <img
              src="https://images.unsplash.com/photo-1758519288372-045de3f65147"
              alt="Trademark rejection reasons"
              className="rounded-2xl shadow-2xl w-full h-auto"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-16 max-w-7xl mx-auto mt-24">
          <div>
            <img
              src="https://images.pexels.com/photos/8112111/pexels-photo-8112111.jpeg"
              alt="Trademark registration cost"
              className="rounded-2xl shadow-2xl w-full h-auto"
            />
          </div>
          <div className="flex flex-col justify-center">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Cost of Trademark Registration</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                When you work with a traditional trademark attorney, you'll often be charged by the hour in addition to the filing fees set by the USPTO. These attorney fees can quickly increase the overall cost of your trademark registration.
              </p>
              <p>
                The USPTO charges a standard application fee of $350 per class of goods or services. Your trademark will need to be renewed after five years, with a $325 renewal fee per class. After that, you'll only need to renew your trademark every 10 years to keep it active.
              </p>
              <p className="bg-gradient-to-br from-emerald-50 to-blue-50 p-6 rounded-xl border-2 border-emerald-200">
                <span className="font-bold text-emerald-600">At Global Trademark USA</span>, we simplify the process and keep it affordable. Our trademark registration package starts at just <span className="font-bold text-2xl text-emerald-600">$45</span> (plus government filing fees), saving you both time and money while ensuring your trademark is registered correctly and efficiently.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoSections;